export default __webpack_public_path__ + "static/media/cob1.a408d1ab.png";